import axios from "axios";

const tablero = {
  state: () => ({
    participantesCategoriaSenasoft: [],
    cuposCategoriaSenasoft: [],
    participantesRegionalSenasoft: [],
    cuposRegionalSenasoft: [],
    lideresCategoriaSenasoft: [],

    participantesHabilidadWorldSkills: [],
    ganadoresHabilidadWorldSkills: [],
    expertosTipoWorldSkills: [],
    acompanantesTipoWorldSkills: [],
    participantesRegionalWorldSkills: [],
    ganadoresRegionalWorldSkills: [],

    participanteSaberesTablero: [],
    participanteCategoriasTablero: [],
    participantesRegionalTablero: [],

    cupoCampesenaSaberesTablero: [],
    cupoCampesenaCategoriasTablero: [],
    cupoCampesenaRegionalTablero: [],
  }),

  getters: {
    obtenerParticipantesCategoriaSenasoft(state) {
      return state.participantesCategoriaSenasoft;
    },

    obtenerCuposCategoriaSenasoft(state) {
      return state.cuposCategoriaSenasoft;
    },

    obtenerParticipantesRegionalSenasoft(state) {
      return state.participantesRegionalSenasoft;
    },

    obtenerCuposRegionalSenasoft(state) {
      return state.cuposRegionalSenasoft;
    },

    obtenerLideresCategoriaSenasoft(state) {
      return state.lideresCategoriaSenasoft;
    },

    obtenerParticipantesHabilidadWorldSkills(state) {
      return state.participantesHabilidadWorldSkills;
    },

    obtenerGanadoresHabilidadWorldSkills(state) {
      return state.ganadoresHabilidadWorldSkills;
    },

    obtenerExpertosTipoWorldSkills(state) {
      return state.expertosTipoWorldSkills;
    },

    obtenerAcompanantesTipoWorldSkills(state) {
      return state.acompanantesTipoWorldSkills;
    },
    obtenerParticipantesRegionalWorldSkills(state) {
      return state.participantesRegionalWorldSkills;
    },
    
    obtenerGanadoresRegionalWorldSkills(state) {
      return state.ganadoresRegionalWorldSkills;
    },

    obtenerParticipanteSaberesTablero(state) {
      return state.participanteSaberesTablero;
    },
    obtenerParticipanteCategoriasTablero(state) {
      return state.participanteCategoriasTablero;
    },
    obtenerParticipantesRegionalTablero(state) {
      return state.participantesRegionalTablero;
    },

    obtenerCuposCampesenaSaberesTablero(state) {
      return state.cupoCampesenaSaberesTablero;
    },
    obtenerCuposCampesenaCategoriasTablero(state) {
      return state.cupoCampesenaCategoriasTablero;
    },
    obtenerCuposCampesenaRegionalTablero(state) {
      return state.cupoCampesenaRegionalTablero;
    },
  },

  mutations: {
    enviarParticipantesCategoriaSenasoft(state, participantesCategoria) {
      state.participantesCategoriaSenasoft = participantesCategoria;
    },

    enviarCuposCategoriaSenasoft(state, cuposCategoria) {
      state.cuposCategoriaSenasoft = cuposCategoria;
    },

    enviarParticipantesRegionalSenasoft(state, participantesRegional) {
      state.participantesRegionalSenasoft = participantesRegional;
    },

    enviarCuposRegionalSenasoft(state, cuposRegional) {
      state.cuposRegionalSenasoft = cuposRegional;
    },

    enviarLideresCategoriaSenasoft(state, lideresCategoria) {
      state.lideresCategoriaSenasoft = lideresCategoria;
    },
    enviarParticipantesHabilidadWorldSkills(state, participantes) {
      state.participantesHabilidadWorldSkills = participantes;
    },

    enviarGanadoresHabilidadWorldSkills(state, ganadores) {
      state.ganadoresHabilidadWorldSkills = ganadores;
    },
    enviarParticipantesRegionalWorldSkills(state, participantes) {
      state.participantesRegionalWorldSkills = participantes;
    },
    
    enviarGanadoresRegionalWorldSkills(state, ganadores) {
      state.ganadoresRegionalWorldSkills = ganadores;
    },

    enviarExpertosTipoWorldSkills(state, expertos) {
      state.expertosTipoWorldSkills = expertos;
    },

    enviarAcompanantesTipoWorldSkills(state, acompanantes) {
      state.acompanantesTipoWorldSkills = acompanantes;
    },

    enviarParticipantesSaberesTablero(state, participantes) {
      state.participanteSaberesTablero = participantes;
    },

    enviarParticipantesCategoriasTablero(state, participantes) {
      state.participanteCategoriasTablero = participantes;
    },

    enviarParticipantesRegionalTablero(state, participantes) {
      state.participantesRegionalTablero = participantes;
    },
    enviarCuposCampesenaSaberesTablero(state, cupos) {
      state.cupoCampesenaSaberesTablero = cupos;
    },
    enviarCuposCampesenaCategoriasTablero(state, cupos) {
      state.cupoCampesenaCategoriasTablero = cupos;
    },
    enviarCuposCampesenaRegionalTablero(state, cupos) {
      state.cupoCampesenaRegionalTablero = cupos;
    },
  },

  actions: {
    participantesCategoriaSenasoft(context, filtros) {
      axios
        .get("api/tablero/participantes/categorias", { params: filtros })
        .then((response) =>
          context.commit(
            "enviarParticipantesCategoriaSenasoft",
            response.data.results,
          ),
        )
        .catch(() => {});
    },

    cuposCategoriaSenasoft(context, filtros) {
      axios
        .get("api/tablero/cupos/categorias", { params: filtros })
        .then((response) =>
          context.commit("enviarCuposCategoriaSenasoft", response.data.results),
        )
        .catch(() => {});
    },

    participantesRegionalSenasoft(context, filtros) {
      axios
        .get("api/tablero/participantes/regionales", { params: filtros })
        .then((response) =>
          context.commit(
            "enviarParticipantesRegionalSenasoft",
            response.data.results,
          ),
        )
        .catch(() => {});
    },

    cuposRegionalSenasoft(context, filtros) {
      axios
        .get("api/tablero/cupos/regionales", { params: filtros })
        .then((response) =>
          context.commit("enviarCuposRegionalSenasoft", response.data.results),
        )
        .catch(() => {});
    },

    lideresCategoriaSenasoft(context, filtros) {
      axios
        .get("api/tablero/lideres/categorias", { params: filtros })
        .then((response) =>
          context.commit(
            "enviarLideresCategoriaSenasoft",
            response.data.results,
          ),
        )
        .catch(() => {});
    },

    // Worldskills
    participantesWorldskillsHabilidadTablero(context, datosFiltro) {
      axios
        .get(`/api/tableroWorldSkills/participantes/habilidades`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarParticipantesHabilidadWorldSkills",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },

    ganadoresHabilidadWorldSkillsTablero(context, datosFiltro) {
      axios
        .get("api/tableroWorldSkills/ganadores/habilidades", {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarGanadoresHabilidadWorldSkills",
            response.data.results,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },

    expertoTipoWorldSkillsTablero(context, datosFiltro) {
      axios
        .get("api/tableroWorldSkills/expertos/tipos", {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarExpertosTipoWorldSkills",
            response.data.results,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },

    acompañantesTipoWorldSkillsTablero(context, datosFiltro) {
      axios
        .get("api/tableroWorldSkills/acompanantes/tipos", {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarAcompanantesTipoWorldSkills",
            response.data.results,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    participantesRegionalWorldskillsTablero(context, datosFiltro) {
      axios
        .get(`/api/tableroWorldSkills/participantes/regionales`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarParticipantesRegionalWorldSkills",
            response.data.results,
          );
        })
    
        .catch((error) => {
          console.error(error);
        });
    },
    
    ganadoresRegionalWorldSkillsTablero(context, datosFiltro) {
      axios
        .get("api/tableroWorldSkills/ganadores/regionales", {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarGanadoresRegionalWorldSkills",
            response.data.results,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //Campesena

    gestionarParticipantesCampesenaSaberesTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/participantes/saberes`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarParticipantesSaberesTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },
    gestionarParticipantesCampesenaCategoriaTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/participantes/categorias`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarParticipantesCategoriasTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },
    gestionarParticipantesCampesenaRegionalTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/participantes/regionales`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarParticipantesRegionalTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },

    gestionarCuposCampesenaSaberesTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/cupos/saberes`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarCuposCampesenaSaberesTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },
    gestionarCuposCampesenaCategoriasTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/cupos/categorias`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarCuposCampesenaCategoriasTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },
    gestionarCuposCampesenaRegionalTablero(context, datosFiltro) {
      axios
        .get(`/api/campesena/tablero/cupos/regionales`, {
          params: datosFiltro,
        })
        .then((response) => {
          context.commit(
            "enviarCuposCampesenaRegionalTablero",
            response.data.results,
          );
        })

        .catch((error) => {
          console.error(error);
        });
    },
  },
};

export default tablero;
